export const findClosestProductType = (value, productTypes, fieldName) => {
    let filteredProductTypes = [];
    
    value = value.trim().toLowerCase();

    for(let i in productTypes) {
        if(!productTypes[i][fieldName]) {
            continue
        }
        let indexOfValueInProductTypeName = getIndexOfSubstring(value, productTypes[i][fieldName])
    
        if (indexOfValueInProductTypeName === -1) {
            continue
        }

        let flag = false
        for(let j in filteredProductTypes) {
            if(indexOfValueInProductTypeName < filteredProductTypes[j][1]) {
                filteredProductTypes.splice(j, 0, [i, indexOfValueInProductTypeName])
                flag = true
                break
            }
        }

        if(!flag) {
            filteredProductTypes.push([i, indexOfValueInProductTypeName])
        }

        filteredProductTypes = filteredProductTypes.slice(0, 50)
    }

    let result = []
    for(let i in filteredProductTypes) {
        let index = filteredProductTypes[i][0]
        result.push(productTypes[index])
    }

    return result 
}

function getIndexOfSubstring(substring, str) {
    return str.toLowerCase().indexOf(substring)
}